import operationUtils from './operationUtils';
import { getGlobalLogger } from '@zg-rentals/logger-base';

export const optanonUtils = () => {
  const isClient = () => {
    return typeof window !== 'undefined';
  };

  const hasOptanon = () => {
    return isClient() && typeof window.Optanon !== 'undefined';
  };

  /**
   * The global object, window.Optanon, is loaded async via MUI Footer component
   * Try and detect window.Optanon multiple times
   *
   * @param {func} callback
   */
  const asyncHasOptanon = (callback: (b: boolean) => void) => {
    if (isClient()) {
      operationUtils.tryAgain(
        {
          delay: 500,
          maxTries: 5,
          detectFunc: hasOptanon,
        },
        (success: boolean) => callback(success),
      );
    }

    return;
  };

  /**
   * The global object, window.Optanon, is loaded async via MUI Footer component
   * Listen for on save click once window.Optanon is available
   *
   * @param {func} callback
   */
  const asyncHandleOnConsentChanged = (callback: () => void) => {
    asyncHasOptanon((success: boolean) => {
      if (success) {
        window.Optanon.OnConsentChanged(() => {
          callback();
        });
      } else {
        getGlobalLogger()?.debug('asyncHandleOnConsentChanged - could not detect window.Optanon');
      }
    });
  };

  return {
    asyncHandleOnConsentChanged,
  };
};
